import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=524baa0f&scoped=true&"
import script from "./Home.vue?vue&type=script&setup=true&lang=js&"
export * from "./Home.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=524baa0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524baa0f",
  null
  
)

export default component.exports